export default "__VITE_ASSET__vC2UqogJ__"